import { BoardNote } from "@/bryntum-lib/models/BoardNote";
import { cn } from "@/modern/utils";
import { DateHelper } from "@bryntum/schedulerpro";

interface NotesListProps {
  notes: BoardNote[];
  activeNoteId: string | number | null;
  onSelectNote: (note: BoardNote) => void;
}

export const NotesList = ({ notes, activeNoteId, onSelectNote }: NotesListProps) => (
  <div className="space-y-1 relative border-l border-border flex flex-col p-2 w-full overflow-auto h-[400px]">
    {notes.map((note) => (
      <button
        key={note.id}
        className={cn("p-2 w-full text-left rounded transition-colors hover:bg-secondary", activeNoteId === note.id && "bg-secondary/20 border border-border/70")}
        onClick={() => onSelectNote(note)}
      >
        <div className="font-medium text-xs truncate text-secondary-foreground">{note.name || "Untitled Note"}</div>
        <div className="text-secondary-foreground/50 text-xs">{DateHelper.format(new Date(note.updatedAt), "MM/DD/YYYY")}</div>
      </button>
    ))}
  </div>
);
